module.exports = __webpack_public_path__ + "img/login-screen.1ece5e46.png";